import React, { Component } from 'react';
import NachBounceUi from '../../../presentationals/Admin/Recovery/NachBounce.component';
import { APIS } from '../../../../utils/api-factory'

class NachBounce extends Component {
    constructor(props) {
        super(props);
        this.state = {
            NachBounceData: '',
            FilteredData: [],
            pageIndexToShow: 0,
        }
    }

    componentWillMount() {
        fetch(APIS.GET_NACH_DATA + 1 + '&type=emi')
            .then(res => res.json())
            .then(json => {
                this.setState({ NachBounceData: json })
            })
    }

    render() {
        return (
            <div className="full-height">
                <NachBounceUi
                    NachBounceData={this.state.NachBounceData}
                    getFilterValue={this.getFilterValue.bind(this)}
                    FilteredData={this.state.FilteredData}
                    getPageValue={this.getPageValue.bind(this)}
                    pageIndexToShow={this.state.pageIndexToShow}
                />
            </div>
        )
    }

    getFilterValue(filtered) {
        this.setState({ FilteredData: filtered })
    }

    getPageValue(pageIndex) {
        this.setState({ pageIndexToShow: pageIndex })
    }

}

export default NachBounce;